module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeft-0444ca20f34e7aedbc0636057bdddb47.png";